import './web.config';
// polyfill import must be up the top
import 'core-js';
import 'core-js/features/url-search-params';
import 'regenerator-runtime/runtime';

import './scss/app.scss';
import './scss/rte.scss';

import '../../Common/js/util/environment';
import '../../Common/js/util/attributeHelper';
import '../../Common/js/util/appLocationCookies';
import '../../Common/js/util/queryStringHelper';
import setWindowCookie from '../../Common/js/util/cookie';
import responsiveImage from './js/util/responsive-image';
import matchHeight from './js/util/match-height';
import './js/util/anchor-scroll';
import './js/util/android-keyboard';
import './js/util/search-highlight';
import after_polyfills_load from '../../Common/js/util/load-polyfills';
import '../../Common/js/util/focus';
import '../../Common/js/util/debouncer';
import '../../Common/modules/form-input/form-input';
import '../../Common/modules/accordion/accordion';
import '../../Common/modules/google-maps/google-maps-places';
import carousel from '../../Common/modules/carousel/carousel';
import './modules/header/primary-nav';

import objectFitVideos from '../../node_modules/object-fit-videos/object-fit-videos';
import './modules/countdown/countdown';
import './modules/dropdown/dropdown';
import './modules/handle-recaptcha/handle-recaptcha';
import './modules/filter/filter';
import './modules/search/search';
import './modules/image-form/image-form';
import './modules/hero/hero';
import './modules/skip-link/skip-link';
import './modules/forms/forms';
import './modules/image-quote/image-quote';
import './modules/listing/listing';
import './modules/sentence-dropdown/sentence-dropdown';
import './modules/advanced-filter/advanced-filter';
import './modules/video/video';
import './modules/map/map';
import './modules/membership/membership';
import './modules/logo-carousel/logo-carousel';
import './modules/addthis/addthis';
import './modules/guided-services/guided-services';
import './modules/analytics/analytics';
import './modules/tracking-tool/tracking-tool';
import './modules/popup/popup';
import './modules/formcta/formcta';
import './modules/vfwc-pages/vfwc-pages';
import './modules/form-tracking/form-tracking';
import './modules/image-slider/jquery.event.move'
import './modules/image-slider/jquery.twentytwenty'
import './modules/image-slider/image-slider';
import './modules/jobadderwidget/jobadderwidget';
import "./modules/gallery-component/gallery";

//Note that polyfills will not start loading until this is run
after_polyfills_load(()=>{
  // Run code in here that depends on the polyfills loading first
  carousel();
  responsiveImage();
  objectFitVideos(document.querySelectorAll('video.hero__media'));
});
setWindowCookie();
